import { ready } from "./utils";
import { locationModal } from "./location-modal-window";
import { counterAnimation } from "./animation";
import { cf7MaskTelValidation } from "./cf7-mask-for-tel";
import { loadMoreOffer } from "./load-more-offer";
import { openAllAccordions } from "./accordions-pre-open";

ready(() => {
  // locationModal();
  counterAnimation();
  cf7MaskTelValidation();
  loadMoreOffer();
  openAllAccordions(); // or openFirstAccordion();
});
